export interface RRIFileUploadError {
  status: number;
  message: string;
}
